import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-apply-for-beta',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './apply-for-beta.html',
  styleUrl: './apply-for-beta.scss',
})
export class ApplyForBeta {}
